const ua = window.navigator.userAgent;
const appName = () => {
    if (ua.includes('dyxc')) return 'dyxc';
};
const appVersion = ()=> {
    let version = ua.split(" ").filter(
        (string) => {
            return (string.indexOf("com.dyxc.banxue") != -1) 
        }
    );
    if(version instanceof Array && version.length > 0){
        var vStr = version[0].replace(/com.dyxc.banxue\//,"");
        return vStr;
    }else{
        return "1.0.0";
    }
}

const ds_app_bridge = {
    state: {
        platform: {
            isApp: ua.includes('dyxc') || ua.includes('dyxc'),
            // isApp: 1,
            isAndroid: ua.includes('Android') || ua.includes('Linux'),
            isIos: ua.indexOf('iPhone') > -1 || ua.indexOf('iPad') > -1 || (ua.indexOf('Macintosh') > -1 && 'ontouchend' in document),
            isAndroidApp: ua.includes('zwwl_education_phone_android') || ua.includes('zwwl_educationhd_phone_android') || ua.includes('zwwl_live_pad_android'),
            isIosApp: ua.includes('zwwl_education_phone_ios') || ua.includes('zwwl_educationhd_phone_ios') || ua.includes('zwwl_live_pad_ios'),
            appName: appName(),
            appVersion: appVersion()
        }, //平台（安卓、ios）
        appInfo: '',
    },
    
    mutations: {
        SET_APP_INFO: (state,data) => {
            state.appInfo = data;
        }
    },

    getters: {
        // 平台信息
        platform: ({ platform }) => platform,
        // 是否为app环境
        isApp: ({ platform: { isApp } }) => isApp,

        isIosApp: ({ platform: { isIosApp } }) => isIosApp,

        isAndroidApp: ({ platform: { isAndroidApp } }) => isAndroidApp,
 
        appInfo: state=> state.appInfo,

        appName: ({ platform: { appName } }) => appName,

        appVersion: ({ platform: { appVersion } }) => appVersion

    }
};

export default ds_app_bridge;
